import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { QuizQuestion } from '../../../types/quiz';
import QuestionCard from './QuestionCard';

interface QuestionListProps {
  questions: QuizQuestion[];
  onAddQuestion: () => void;
  onEditQuestion: (question: QuizQuestion) => void;
  onDeleteQuestion: (question: QuizQuestion) => void;
  isPublished?: boolean;
}

/**
 * Displays the list of quiz questions
 * Shows empty state when no questions exist, or renders QuestionCard for each question
 */
const QuestionList: React.FC<QuestionListProps> = ({
  questions,
  onAddQuestion,
  onEditQuestion,
  onDeleteQuestion,
  isPublished = false,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">
          Questions ({questions.length})
        </Typography>
        {!isPublished && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={onAddQuestion}
          >
            Add Question
          </Button>
        )}
      </Box>

      {questions.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No questions added yet
          </Typography>
          {!isPublished && (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Add questions to your quiz to get started
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={onAddQuestion}
              >
                Add First Question
              </Button>
            </>
          )}
        </Paper>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {questions.map((question, index) => (
            <QuestionCard
              key={question.id}
              question={question}
              index={index}
              onEdit={onEditQuestion}
              onDelete={onDeleteQuestion}
              isPublished={isPublished}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default QuestionList;
